import React, { Component } from 'react';
import PropTypes from "prop-types";
import OrderBySearchStates from "../../constants/states/OrderBySearchStates";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";

export default class PublicSERPFiltersView extends Component {

    static propTypes = {
        minPrice: PropTypes.number.isRequired,
        maxPrice: PropTypes.number.isRequired,
        orderBy: PropTypes.symbol.isRequired,
        placeId: PropTypes.string.isRequired,
        distance: PropTypes.number.isRequired,
        mapCurrentCenter: PropTypes.shape({
            latitude: PropTypes.number.isRequired,
            longitude: PropTypes.number.isRequired
        }).isRequired,
        activePage: PropTypes.number.isRequired,
    };
    handleSearch = (event) => {
        event.preventDefault();
        EventPublisher.publish(UIInteractionEvents.FILTER_BUTTON_CLICKED,
            {
                "placeId": this.props.placeId,
                "maxPrice": this.props.maxPrice,
                "minPrice": this.props.minPrice,
                "orderBy": this.props.orderBy,
                "distance": this.props.distance,
                "latitude": this.props.mapCurrentCenter.latitude,
                "longitude": this.props.mapCurrentCenter.longitude,
                "activePage": this.props.activePage});

    }

    render() {
        return (
            <div className="card light-grey-bg mb-2 w-100">
                <form className="form" onSubmit={this.handleSearch}>
                    <div className="form-row m-0 pt-2">
                        <label className="col-lg-3 col-sm-12 col-form-label-sm">Price</label>
                        <input
                            type="number"
                            min="0"
                            placeholder="min"
                            className="form-control col-lg-3 col-sm-12 form-control-sm"
                            aria-label="min price filter"
                            onChange={(e) => EventPublisher.publish(UIInteractionEvents.MIN_PRICE_CHANGED, e.target.value)}
                        />
                        <label className="col-lg-1 col-sm-12 col-form-label-sm text-center">to</label>
                        <input
                            type="number"
                            min="1"
                            placeholder="max"
                            className="form-control col-lg-3 col-sm-12 form-control-sm mr-2"
                            aria-label="min price filter"
                            onChange={(e) => EventPublisher.publish(UIInteractionEvents.MAX_PRICE_CHANGED, e.target.value)}
                        />
                    </div>
                    <div className="form-row m-0">
                        <label className="col-lg-3 col-sm-12 col-form-label-sm">Sort by</label>
                        <select
                            className="form-control col-lg-7 col-sm-12 form-control-sm mr-2"
                            value={this.props.orderBy.description}
                            onChange={(e) => EventPublisher.publish(UIInteractionEvents.ORDER_BY_CHANGED, e.target.value)}>
                            <option value={OrderBySearchStates.DISTANCE_CLOSEST.description}>
                                Distance (Closest)
                            </option>
                            <option value={OrderBySearchStates.PRICE_HIGH_TO_LOW.description}>
                                Price (High to Low)
                            </option>
                            <option value={OrderBySearchStates.PRICE_LOW_TO_HIGH.description}>
                                Price (Low to High)
                            </option>
                        </select>
                    </div>
                    <div className="form-row m-0">
                        <button type="submit" className="btn btn-primary btn-sm col-lg-12 col-sm-12 ">
                            <i className="fas fa-filter mr-1"/>
                            Filter
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

